<template>
  <div class="home">
      		<div class="main-panel">
			<div class="content">



				<div class="panel-header bg-primary-gradient">
					<div class="page-inner py-5">
						<div class="d-flex align-items-left align-items-md-center flex-column flex-md-row">
							<div>
								<h2 class="text-white pb-2 fw-bold">Dashboard</h2>
								<h5 class="text-white op-7 mb-2">Dinas Ketahanan Pangan</h5>
							</div>
							<div class="ml-md-auto py-2 py-md-0">
								<a href="#" class="btn btn-white btn-border btn-round mr-2">Manage</a>
								<a href="#" class="btn btn-secondary btn-round">Add Customer</a>
							</div>
						</div>
					</div>
				</div>





				<div class="page-inner mt--5">


                <div class="row">
                    <div class="col-sm-6 col-md-3">
                        <div class="card card-stats card-round">
                            <div class="card-body ">
                                <div class="row align-items-center">
                                    <div class="col-icon">
                                        <div class="icon-big text-center icon-primary bubble-shadow-small">
                                            <i class="fas fa-leaf"></i>
                                        </div>
                                    </div>
                                    <div class="col col-stats ml-3 ml-sm-0">
                                        <div class="numbers">
                                            <p class="card-category">Jumlah Jenis Pangan</p>
                                            <h4 class="card-title">{{widget.master_bahan_pangan}}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-3">
                        <div class="card card-stats card-round">
                            <div class="card-body">
                                <div class="row align-items-center">
                                    <div class="col-icon">
                                        <div class="icon-big text-center icon-info bubble-shadow-small">
                                            <i class="fas fa-apple-alt"></i>
                                        </div>
                                    </div>
                                    <div class="col col-stats ml-3 ml-sm-0">
                                        <div class="numbers">
                                            <p class="card-category">Jumlah Komoditi</p>
                                            <h4 class="card-title">{{widget.master_komoditi}}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-3">
                        <div class="card card-stats card-round">
                            <div class="card-body">
                                <div class="row align-items-center">
                                    <div class="col-icon">
                                        <div class="icon-big text-center icon-success bubble-shadow-small">
                                            <i class="fas fa-clipboard-list"></i>
                                        </div>
                                    </div>
                                    <div class="col col-stats ml-3 ml-sm-0">
                                        <div class="numbers">
                                            <p class="card-category">Jumlah Kecamatan</p>
                                            <h4 class="card-title">{{widget.jml_kecamatan}}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-3">
                        <div class="card card-stats card-round">
                            <div class="card-body">
                                <div class="row align-items-center">
                                    <div class="col-icon">
                                        <div class="icon-big text-center icon-secondary bubble-shadow-small">
                                            <i class="fas fa-clipboard"></i>
                                        </div>
                                    </div>
                                    <div class="col col-stats ml-3 ml-sm-0">
                                        <div class="numbers">
                                            <p class="card-category">Jumlah Desa/Kel</p>
                                            <h4 class="card-title">{{widget.des_kel}}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6 col-md-6">
                        <div class="card card-stats card-round">
                            <div class="card-body">
                                <span class="h_isitabl2">CAPAIAN LUAS TANAM PADI / BULAN</span> <hr>
                                <div class="row align-items-center">
                                    <canvas id="capaian_luas_tanam_bulan" width="400" height="300"></canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-6">
                        <div class="card card-stats card-round">
                            <div class="card-body">
                                <span class="h_isitabl2">PRESENTASE LUAS TANAMAN PADI TIAP KECAMATAN</span> <hr>
                                <div class="row align-items-center">
                                    <canvas id="capaian_luas_tanam_kecamatan" width="400" height="300"></canvas>

                                    <!-- <agile :nav-buttons="false" :autoplay-speed="5000" :speed="2500" fade="fade" pause-on-hover="pause-on-hover" pause-on-dots-hover="pause-on-dots-hover" autoplay="autoplay">
                                        <img class="slide" src="https://images.unsplash.com/photo-1509549649946-f1b6276d4f35?ixlib=rb-1.2.1&amp;q=80&amp;fm=jpg&amp;crop=entropy&amp;cs=tinysrgb&amp;w=1600&amp;fit=max&amp;ixid=eyJhcHBfaWQiOjE0NTg5fQ"/>
                                        <img class="slide" src="https://images.unsplash.com/photo-1511469054436-c7dedf24c66b?ixlib=rb-1.2.1&amp;q=80&amp;fm=jpg&amp;crop=entropy&amp;cs=tinysrgb&amp;w=1600&amp;fit=max&amp;ixid=eyJhcHBfaWQiOjEyMDd9"/>
                                        <img class="slide" src="https://images.unsplash.com/photo-1511135232973-c3ee80040060?ixlib=rb-1.2.1&amp;q=80&amp;fm=jpg&amp;crop=entropy&amp;cs=tinysrgb&amp;w=1600&amp;fit=max&amp;ixid=eyJhcHBfaWQiOjEyMDd9"/>
                                        <img class="slide" src="https://images.unsplash.com/photo-1511231683436-44735d14c11c?ixlib=rb-1.2.1&amp;q=80&amp;fm=jpg&amp;crop=entropy&amp;cs=tinysrgb&amp;w=1600&amp;fit=max&amp;ixid=eyJhcHBfaWQiOjEyMDd9"/>
                                        <img class="slide" src="https://images.unsplash.com/photo-1517677129300-07b130802f46?ixlib=rb-1.2.1&amp;q=80&amp;fm=jpg&amp;crop=entropy&amp;cs=tinysrgb&amp;w=1600&amp;fit=max&amp;ixid=eyJhcHBfaWQiOjEyMDd9"/>
                                    </agile> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6 col-md-6">
                        <div class="card card-stats card-round">
                            <div class="card-body">
                                <span class="h_isitabl2">PRESENTASE GIZI BKP TIAP KECAMATAN</span> <hr>
                                <div class="row align-items-center">
                                    <canvas id="presentase_gizi" width="400" height="300"></canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-6">
                        <div class="card card-stats card-round">
                            <div class="card-body">
                                <span class="h_isitabl2">RERATA PANEL HARGA PANGAN</span> <hr>
                                <div class="row align-items-center">
                                    <canvas id="panel_harga" width="400" height="300"></canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        </div>


      <!-- Footer -->
        <foother></foother>
		<!-- End Footer -->


		</div>
  </div>
</template>

<script>

const ADD_URL = URL_APP + "api/v1/statistik_ketapang_home/";

export default {
    data() {
        return {
            list_data: [],
            widget : {},
            Warna: [
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 159, 64, 0.2)',
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                    ],
           
        }
    },
    methods: {
        Widget : function(){
            fetch(ADD_URL+'widget', {
                method : 'get',
                headers : {
                    'content-type' : 'application/json',
                    authorization: "kikensbatara " + localStorage.token,
                },

            })
            .then(res => res.json())
            .then ((res_data) =>{
                this.widget = res_data;

            })
        },

        
        capaian_luas_tanam_bulan : function(varData, varLable){

            fetch(ADD_URL+'luasTanamBulan', {
                method : 'get',
                headers : {
                    'content-type' : 'application/json',
                    authorization: "kikensbatara " + localStorage.token,
                },

            })
            .then(res => res.json())
            .then ((res_data) =>{
                console.log(res_data)

                var ctx = document.getElementById('capaian_luas_tanam_bulan');
                var myChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: ['Jan','feb','mar','apr','mei','jun','jul','agu','sep','okt','nov','des',],
                        datasets: [{
                            label: 'Luas Tanam',
                            data: [
                                res_data.jan,
                                res_data.feb,
                                res_data.mar,
                                res_data.apr,
                                res_data.mei,
                                res_data.jun,
                                res_data.jul,
                                res_data.agu,
                                res_data.sep,
                                res_data.okt,
                                res_data.nov,
                                res_data.des,
                            ],
                            backgroundColor: ['rgba(255, 159, 64, 0.2)'],
                            borderWidth: 1
                        }]
                    },
                    options: {
                        legend: {display: false,},
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        }
                    }
                });

                
            })

            
        },

        capaian_luas_tanam_kecamatan : function(){
            fetch(ADD_URL+'luasTanamKecamatan', {
                method : 'get',
                headers : {
                    'content-type' : 'application/json',
                    authorization: "kikensbatara " + localStorage.token,
                },

            })
            .then(res => res.json())
            .then ((res_data) =>{
                // console.log(res_data)
                var nama_kecamatan = [];
                var rata_rata = [];
                for (let i = 0; i < res_data.length; i++) {
                    nama_kecamatan.push(res_data[i].nama_kecamatan);
                    rata_rata.push(res_data[i].rata_rata)
                    
                }
    
                var ctx = document.getElementById('capaian_luas_tanam_kecamatan');
                var myChart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: nama_kecamatan,
                    datasets: [{
                        label: 'LUAS LAHAN',
                        data: rata_rata,
                        backgroundColor: this.Warna,
                        borderColor: this.Warna,
                        borderWidth: 1
                    }]
                },
                options: {
                    legend: {display: false,},
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            });


                
            })

        },

        presentase_gizi : function(){
            fetch(ADD_URL+'presentase_gizi', {
                method : 'get',
                headers : {
                    'content-type' : 'application/json',
                    authorization: "kikensbatara " + localStorage.token,
                },

            })
            .then(res => res.json())
            .then ((res_data) =>{
                // console.log(res_data)
                var nama_kecamatan = [];
                var datanya = [];
                for (let i = 0; i < res_data.length; i++) {
                    nama_kecamatan.push(res_data[i].nama_kecamatan);
                    datanya.push(res_data[i].datanya)
                    
                }
    
                var ctx = document.getElementById('presentase_gizi');
                var myChart = new Chart(ctx, {
                    type: 'pie',
                    data: {
                        labels: nama_kecamatan,
                        datasets: [{
                            label: 'LUAS LAHAN',
                            data: datanya,
                            backgroundColor: this.Warna,
                            borderWidth: 1
                        }]
                    },
                    options: {
                        legend: {display: false,},
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        }
                    }
                });


                
            })
        }

    },
    mounted() {
        this.Widget();
        this.capaian_luas_tanam_kecamatan();
        this.capaian_luas_tanam_bulan();
        this.presentase_gizi();



        
    },

}
</script>
